import React from 'react';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import { PEEntryNudgeWrapper, LogoWrapper, Logo, Heading, TagText, Row, Column, CtaBtn } from './PEEntryNudge.style';
import { IMAGE_URL } from 'constants/index';

export interface IGenericCssObject {
  styles: {
    [key: string]: {
      [key: string]: string | number;
    }
  }
}

interface IEntryNudgeData {
  h1?: string;
  h2?: string;
  ctaText?: string;
  ctaLink?: string;
  imgmsid?: string;
  logo?: string;
  bgImg?: string;
}

export interface IUserData {
  isLoggedIn: boolean;
  prcValue: number;
  showConsentPopUp?: boolean;
}

interface IPEEntryNudgeProps {
  isWapView: boolean;
  backgroundImage?: string;
  data: IEntryNudgeData;
  userData?: IUserData;
  href: string;
  fireGA: () => {};
  gaCategory: string,
  gaAction: string,
}

const PEEntryNudgeStyle = {
  peEntryNudge: {
    background: '#FFF5F6',
    margin: '40px 0',
    padding: '32px',
    borderRadius: '24px',
    borderRadiusMobile: '12px',
    paddingMobile: '0 16px 16px',
    marginMobile: '20px 16px',
  },
};

const RowStyle = {
  row: {
    display: 'flex',
    alignItems: 'center',
  }
}

const ColumnStyle = {
  column: {
    padding: '0 20px',
  }
}

const LogoWrapperStyle = {
  logoWrapper: {
    background: 'url(https://static.toiimg.com/photo/99751718.cms) no-repeat',
    margin: '0 -16px 16px',
    padding: '16px 16px 4px',
    backgroundSize: 'cover',
  }
}

const LogoStyle = {
  logo: {
    marginBottom: '12px',
    widthMobile: '80px',
    verticalAlignMobile: 'middle',
  }
}

const HeadingStyle = {
  heading: {
    fontSize: '32px',
    lineHeight: '44px',
    color: '#1a1a1a',
    marginBottom: '12px',
    fontSizeMobile: '20px',
    lineHeightMobile: '24px',
  }
}
const TagTextStyle = {
  tagText: {
    fontSize: '24px',
    lineHeight: '36px',
    color: '#595959',
    marginBottom: '40px',
    fontSizeMobile: '14px',
    lineHeightMobile: '20px',
    marginBottomMobile: '16px',
  }
}

const CtaBtnStyle = {
  ctaBtn: {
    fontSize: '16px',
    lineHeight: '40px',
    color: '#fff',
    fontWeight: '700',
    textAlign: 'center',
    display: 'block',
    background: '#E21B22',
    height: '40px',
    borderRadius: '8px',
    fontSizeMobile: '12px',
    heightMobile: '32px',
    lineHeightMobile: '32px',
  }
}

export default function PEEntryNudge(props: IPEEntryNudgeProps) {
  const { isWapView, userData, data, gaCategory, gaAction } = props;
  const isLoggedIn = userData?.isLoggedIn;
  const prcValue = userData && userData.prcValue ? userData.prcValue : 0;
  if (!data) {
    return null;
  }

  const fireGA = (category: string, action: string) => {
    analyticsWrapper(
      'ga',
      'send',
      'event',
      `${category}`,
      `${action}`,
      `Ps-${!isLoggedIn && prcValue === 0 ? -1 : prcValue}`
      , {
        nonInteraction: 0
      }
    )
  }
  return (

    <PEEntryNudgeWrapper styles={PEEntryNudgeStyle}>
      {isWapView ? <>
        <LogoWrapper styles={LogoWrapperStyle}>
          <Logo src={`${IMAGE_URL}${data.logo}.cms`} alt="image" styles={LogoStyle}></Logo>
        </LogoWrapper>
        {data.h1 &&
          <Heading styles={HeadingStyle}>{data.h1}</Heading>
        }
        {data.h2 &&
          <TagText styles={TagTextStyle}>{data.h2}</TagText>
        }
        <CtaBtn styles={CtaBtnStyle} href={data?.ctaLink}
          onClick={() => {
            fireGA(gaCategory, gaAction)
          }}
        >{data?.ctaText}</CtaBtn>
      </>
        : <Row styles={RowStyle}>
          <Column styles={ColumnStyle}>
            <img src={`${IMAGE_URL}${data?.imgmsid}.cms`} alt="image" />
          </Column>
          <Column styles={ColumnStyle}>
            <Logo src={`${IMAGE_URL}${data.logo}.cms`} alt="image" styles={LogoStyle}></Logo>
            {data.h1 &&
              <Heading styles={HeadingStyle}>{data.h1}</Heading>
            }
            {data.h2 &&
              <TagText styles={TagTextStyle}>{data.h2}</TagText>
            }
            <CtaBtn styles={CtaBtnStyle} href={data?.ctaLink}
              onClick={() => {
                fireGA(gaCategory, gaAction)
              }}>{data?.ctaText}</CtaBtn>
          </Column>
        </Row>
      }
    </PEEntryNudgeWrapper >
  );
}

